/* Ventara One — slider, tabs and product rails */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class VoSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    start() {
      const seconds = Number(this.dataset.autoplay || 0);
      if (!seconds || reduceMotion) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }
    stop() { clearInterval(this.timer); }
    go(i, user) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a, button').forEach((el) => (on ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1')));
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === this.index)));
      if (user) this.start();
    }
  }
  if (!customElements.get('vo-slider')) customElements.define('vo-slider', VoSlider);

  class VoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, k) => {
        t.setAttribute('aria-selected', String(k === i));
        t.tabIndex = k === i ? 0 : -1;
      });
      this.panels.forEach((p, k) => (p.hidden = k !== i));
    }
  }
  if (!customElements.get('vo-tabs')) customElements.define('vo-tabs', VoTabs);

  class VoRail extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      if (!track) return;
      const step = () => track.clientWidth * 0.8;
      this.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      this.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    }
  }
  if (!customElements.get('vo-rail')) customElements.define('vo-rail', VoRail);
})();
